export default {
  name: 'SelectPageSelect',
  props: {
    picked: Array,
    disabled: Boolean,
    clear: Boolean,
    placeholder: String
  },
  inject: ['i18n', 'renderCell'],
  render: function render(h) {
    var _this = this;

    var children = [];
    var result = null;
    if (this.picked && this.picked.length) {
      result = h('span', { domProps: { innerHTML: this.renderCell(this.picked[0]) }, attrs: { title: this.renderCell(this.picked[0]) } });
    } else {
      result = h('span', { class: 'sp-placeholder' }, this.placeholder);
    }
    children.push(h('div', { class: 'sp-base sp-input' }, [result]));
    // clear button
    if (this.clear && this.picked && this.picked.length && !this.disabled) {
      children.push(h('div', {
        class: 'sp-clear',
        attrs: {
          title: this.i18n.clear
        },
        on: {
          click: function click(e) {
            e.stopPropagation();
            _this.remove();
          }
        }
      }, [h('i', { class: 'sp-iconfont sp-icon-close' })]));
    }
    return h('div', children);
  },

  methods: {
    remove: function remove() {
      this.$emit('remove');
    }
  }
};


//////////////////
// WEBPACK FOOTER
// ./src/component/dic/components/Select.js
// module id = 12
// module chunks = 0